export interface AllDoneContent {
  hasAppointment: boolean
  subtitle: string
}

/**
 * The questionnaire can finish without an appointment: when it matches no
 * booking the backend files a new case and staff call the patient to book.
 * Only claim an appointment when the response carried one.
 */
export const allDoneContent = (startDateTime?: string): AllDoneContent => {
  const hasAppointment = Boolean(startDateTime?.trim());
  return {
    hasAppointment,
    subtitle: hasAppointment
      ? 'Questionnaire submitted and appointment confirmed. Nothing more to do right now.'
      : "We've received your questionnaire. Our team will contact you to book your assessment.",
  };
};
